<app-header [logoImg]="logoImg" stickyLogoImg="../../../assets/imgs/logo/se2in_logo_fullwhite.png" [stickyHeaderWhite]="true"></app-header>
<app-revolution-slider-wp></app-revolution-slider-wp>
<app-hosting-list></app-hosting-list>
<app-process></app-process>
<app-help></app-help>
<app-service-tab></app-service-tab>
<app-plan></app-plan>
<app-our-blog></app-our-blog>
<app-our-partners></app-our-partners>
<app-footer></app-footer>
